import React from "react";

import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import AssistantIcon from "../../assets/icons/AssistantIcon";
import DialogsIcon from "../../assets/icons/DialogsIcon";
import IntegrationIcon from "../../assets/icons/IntegrationIcon";
import LeftNavBar from "../../components/LeftNavBar/LeftNavBar";
import ModalAddIntegration from "../../components/ModalAddIntegration/ModalAddIntegration";
import ModalSendUserMessage from "../../components/ModalSendUserMessage/ModalSendUserMessage";
import styles from "./ScreenLayout.module.scss";
import { WalletIcon } from "../../assets/icons/WalletIcon";

export default function ScreenLayout({ children }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;

  const isLogin = useSelector((state) => state.user.isLogin);

  React.useEffect(() => {
    if (!isLogin) navigate("/");
  }, [dispatch, isLogin, navigate]);

  const navData = [
    {
      title: "Диалоги",
      icon: <DialogsIcon fill={pathname.startsWith("/dialog") && "#fff"} />,
      pathname: "/dialog",
      titleHeader: "Диалоги",
    },
    // {
    // 	title: 'Бизнес-процессы',
    // 	icon: <ProcessIcon />,
    // 	pathname: '/bp/add',
    // 	titleHeader: 'Бизнес-процессы (создание)',
    // 	child: [
    // 		{ title: 'Создание процесса', pathname: '/bp/add' },
    // 		{
    // 			title: 'Список процессов',
    // 			pathname: '/bp/list',
    // 			titleHeader: 'Бизнес-процессы (список)',
    // 		},
    // 	],
    // },
    // {
    // 	title: 'Синтез данных',
    // 	icon: <DataIcon />,
    // 	pathname: '/synthesis',
    // 	titleHeader: 'Синтез данных',
    // },
    {
      title: "Ассистенты",
      icon: (
        <AssistantIcon fill={pathname.startsWith("/assistants") && "#fff"} />
      ),
      pathname: "/assistants",
      titleHeader: "Ассистенты",
    },
    {
      title: "Интеграции",
      icon: (
        <IntegrationIcon fill={pathname.startsWith("/integration") && "#fff"} />
      ),
      pathname: "/integration",
      titleHeader: "Интеграции",
    },
    {
      title: "Кошелек",
      icon: <WalletIcon fill={pathname.startsWith("/wallet") && "#fff"} />,
      pathname: "/wallet",
      titleHeader: "Кошелек",
    },
  ];

  return (
    <div className={`${styles.container}`}>
      {pathname === "/integration" && <ModalAddIntegration />}
      <ModalSendUserMessage />
      <LeftNavBar navData={navData} pathname={pathname} />
      <div className={`${styles.content}`}>
        {/* <ScreenHeader navData={navData} pathname={pathname} /> */}
        <div className={`${styles.body}`}>{children}</div>
      </div>
    </div>
  );
}
